import React from 'react';
import maybeComponent from '../../../utils/maybe-component/index';
import renderNothing from '../../../utils/render-nothing';
import {
  Circle,
  DialArm,
  DialInner,
  DialScore,
  DialText,
  DialWrapper,
  InnerSmallCircle,
  SmallCircle,
  Triangle
} from './styles';

const UserScoreSection = ({ score }) => (
  <>
    Q<DialScore score={score}>{score.toFixed(1)}</DialScore>
  </>
);

const QscoreNa = () => 'N/A';

const MaybeUserScoreSection = maybeComponent(QscoreNa)(UserScoreSection);

const MaybeDialArm = maybeComponent(renderNothing)(DialArm);

const QScoreDialCircle = ({ score }) => (
  <DialWrapper score={score}>
    <Circle />
    <SmallCircle>
      <InnerSmallCircle>
        <DialText>
          <MaybeUserScoreSection score={score} condition={!score} />
        </DialText>
      </InnerSmallCircle>
    </SmallCircle>
    <MaybeDialArm score={score} condition={!score} />
    <Triangle />
  </DialWrapper>
);

const WidgetContent = ({ score }) => (
  <DialInner>
    <QScoreDialCircle score={score} />
  </DialInner>
);

const QScoreDial = ({ score }) => <WidgetContent score={score} />;

export default QScoreDial;
